/** @jsx jsx */
import { css, jsx } from '@emotion/core'
import { useState, useContext, useEffect } from 'react'
import {
  Input as LCInput,
  Button,
  notificationConnect,
} from '@livechat/design-system'

import api from '../api'
import { Context } from '../context'

const formatNotification = (
  content,
  variant = 'error',
  autoHideDelayTime = 4000,
  removable = true,
  horizontalPosition = 'center',
  verticalPosition = 'top'
) => ({
  type: 'toast',
  autoHideDelayTime,
  payload: {
    variant,
    content,
    horizontalPosition,
    verticalPosition,
    removable,
  },
})

const wrapperCss = css`
  width: 100%;
  margin-bottom: 10px;
`

const containerCss = css`
  display: flex;
`

const labelCss = css`
  display: inline-block;
  margin-bottom: 5px;
  font-size: 14px;
  font-weight: 300;
`

const inputCss = css`
  width: 100%;
  height: 40px;
`

const errorCss = css`
  font-size: 12px;
  color: #d64646;
  margin-top: 5px;
`

const btnCss = css`
  height: 40px;
  margin-left: 10px;
  width: 100px;
`

const ContentField = ({
  contentName,
  survey,
  placeholder,
  label,
  dataTest,
  notificationSystem,
}) => {
  const { surveyToken } = useContext(Context)

  const [defaultValue, setDefaultValue] = useState(
    survey?.staticContent?.[contentName] || ''
  )
  const [value, setValue] = useState(defaultValue)
  const [error, setError] = useState()
  const [isLoading, setIsLoading] = useState(false)
  const [isDirty, setIsDirty] = useState(false)

  useEffect(() => {
    setIsDirty(value !== defaultValue)
  }, [value, defaultValue])

  const onSubmit = async () => {
    setIsLoading(true)
    try {
      await api.updateStaticContent(surveyToken, survey.id, {
        [contentName]: value,
      })
      setDefaultValue(value)
      notificationSystem.add(
        formatNotification('Static content configured successfully!', 'success')
      )
    } catch (err) {
      notificationSystem.add(formatNotification(error.message))
      console.log(err)
    }
    setIsLoading()
    setError()
  }

  return (
    <div css={wrapperCss}>
      <span css={labelCss}>{label}</span>
      <div css={containerCss}>
        <LCInput
          css={inputCss}
          value={value}
          onChange={(e) => setValue(e.target.value)}
          error={error}
          placeholder={placeholder}
          data-cy={dataTest}
        />
        <Button
          onClick={onSubmit}
          css={btnCss}
          loading={isLoading}
          disabled={!isDirty}
        >
          Save
        </Button>
      </div>
      {error && <span css={errorCss}>{error}</span>}
    </div>
  )
}

export default notificationConnect(ContentField)
